<template>
  <router-view />
</template>

<script>
export default {
  name: 'TradesRouter',
};
</script>
